import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const Logo = styled.img`
  display: inline-block;
  width: ${props => props.large ? '250px': 'auto'};
  max-width: 250px;
  @media (min-width: ${breakpoints.desktop}) {
    width: ${props => props.large ? '390px' : 'auto'};
  }
`;

export default Logo;



// WEBPACK FOOTER //
// ./src/styled-components/Logo.js